import { useDeepCompareEffect } from '../../../../hooks/useDeepCompareEffect';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { setSelectedInitiativeFocus } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { useFilterWasTouched } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { getDefaultInitiativeSelection } from '../../process-analysis.helpers';

/**
 * Hook to handle auto-selection of initiative focus when filters haven't been touched by the user
 *
 * @returns {void}
 */
const useAutoSelectFilters = (): void => {
  const data = useProcessAnalysisStore((state) => state.initiativeFocusData);
  const initiativeFocusWasTouched = useFilterWasTouched('selectedInitiativeFocus');

  useDeepCompareEffect(() => {
    if (data?.initiatives && !initiativeFocusWasTouched) {
      const defaultSelection = getDefaultInitiativeSelection(data.initiatives);
      setSelectedInitiativeFocus(defaultSelection);
    }
  }, [data?.initiatives, initiativeFocusWasTouched]);
};

export { useAutoSelectFilters };
